import styled from 'styled-components';

export const SubtitleContainer = styled.div`
    font-size: 16px;
    font-weight: 500;
    color: #333;
    margin-bottom: 16px;
    text-align: start;
`; 